import type { TResponseGetAccountsByCoaId } from "@/apis/odin/apiODIN";
import type { TAccountDTO } from "./accountTypes";

export const convertAccountsResponseToDTO = (
    accounts: TResponseGetAccountsByCoaId,
): TAccountDTO[] => {
    const accountsSortedByDisplayOrderFromLowestToHighest = accounts.toSorted(
        (a, b) => a.displayOrder - b.displayOrder,
    );

    return accountsSortedByDisplayOrderFromLowestToHighest.map(account => ({
        id: account.accountId,
        account: account.accountName,
        code: account.accountCode,
        subcategory: account.subcategory ?? null,
        type: account.accountType,
        section: account.section ?? null,
        mappedFrom: account.mappedFrom,
        displayOrder: account.displayOrder,
        includeInSummarizedDocument: ["income", "expense"].includes(
            account.accountType,
        ),
        isEdited: false,
    }));
};
